import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { shareReplay } from 'rxjs';
import { AppCommonModule } from 'src/app/common.module';
import { CarouselImage } from 'src/app/components/carousel/images/carousel-image.model';
import { CarouselImagesComponent } from 'src/app/components/carousel/images/carousel-images.component';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { SelectSiteButtonComponent } from 'src/app/components/select-site/select-site.component';
import { TakeVideoComponent } from 'src/app/components/take-video/take-video.component';
import { FileUpload } from 'src/app/models/file.model';
import { Instruction } from 'src/app/models/instruction.model';
import { Site } from 'src/app/models/site.model';
import { InstructionsService } from 'src/app/services/instructions.service';
import { LoadingService } from 'src/app/services/loading.service';
import { SitesService } from 'src/app/services/sites.service';
import { UploadService } from 'src/app/services/upload.service';

@Component({
  selector: 'app-new-item-dialog',
  templateUrl: './new-item.dialog.html',
  styleUrls: ['./new-item.dialog.scss'],
  imports: [

    CommonModule,
    AppCommonModule,
    TakeVideoComponent,
    SelectSiteButtonComponent,
    MainDialogComponent,
    CarouselImagesComponent,
  ],
})
export class NewItemDialogComponent {
  private loadingService = inject(LoadingService);
  private sitesService = inject(SitesService);
  private uploadService = inject(UploadService);

  sites$ = this.sitesService.getActiveList().pipe(
    shareReplay(1),
  );

  formGroup: FormGroup;
  typeS = signal<'general' | 'residence'>('general');
  selectedSite = signal<Site>(null);
  video = signal<CarouselImage[]>([]);

  constructor(
    private instructionsService: InstructionsService,
    private _modal: ModalController,
    formBuilder: FormBuilder,
    navParams: NavParams,
  ) {
    this.typeS.set(navParams.get('type'));
    const item = navParams.get<Instruction>('item');

    this.formGroup = formBuilder.group({
      guid: [item?.guid ?? null],
      text: [item?.text ?? null],
      name: formBuilder.group({
        fi: [item?.name.fi ?? '', Validators.required],
      }),
      video: [item?.video ?? null],
      url: [item?.url ?? null],
      client: [item?.client ?? null],
      site: [item?.site ?? null, this.typeS() === 'residence' ? Validators.required : Validators.nullValidator],
      public: [item?.public ?? false],
    });
  }

  onVideoUrl(video: string) {
    this.formGroup.get('video').setValue(video);
    this.video.set([{ url: video, type: 'video' }]);
  }

  async selectFiles(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    this.loadingService.showLoading();
    for (let file of Array.from(files)) {
      const fileupload = new FileUpload(file);
      fileupload.guid = 'instruction-' + new Date().toISOString();
      const downloadUrl = await this.uploadService.uploadImage(fileupload);
      this.formGroup.get('url').setValue(downloadUrl);
    }
    this.loadingService.hideLoading();
  }

  selectSite(site: Site) {
    this.formGroup.get('site').setValue(site ? { guid: site.guid, name: site.name } : null);
    this.selectedSite.set(site);
  }

  onSave() {
    const value = this.formGroup.value;
    if (value.guid) {
      this.instructionsService.update(value).then(() => this.dismiss());
    } else {
      this.instructionsService.save(value).then(() => this.dismiss());
    }
  }

  dismiss() {
    this._modal.dismiss();
  }
}
